import { getCookie } from '@/utils/index.js';

function setCssVars(data) {
    const darkMode = document.getElementsByTagName('html')[0].attributes['data-dark-mode']?.value;
    const darkColor = data?.dark_mode_text_color;
    const root = document.documentElement;
    const rgb = hexToRgb(data.main_color);

    let styles = {
        primary: { name: '--primary', data: data.main_color },
        primary_color: { name: '--primary-color', data: data.main_color },
        primary_rgb: { name: '--primary-rgb', data: `${rgb.r},${rgb.g},${rgb.b}`},
        overlay_rgb: { name: '--overlay_rgb', data: `${rgb.r},${rgb.g},${rgb.b}`}
    }

    if(darkMode === 'true' && darkColor) { 
        styles.primary_color = { name: '--primary-color', data: darkColor, important: true },
        styles.text_dark = { name: '--text-dark', data: darkColor, important: true };
    }

    let cssImages = [
        {
            name: `--dropdown-icon`,
            url:`/images/select_dropdown.svg`
        }
    ];

    cssImages.forEach(image => {
        let path = window.rmsBasePath ? window.rmsBasePath : '';
        root.style.setProperty(image.name, `url(${path}${image.url})`);
    });

    Object.keys(styles).forEach(key => {
        const style = styles[key];
        root.style.setProperty(style.name, style.data, style?.hasOwnProperty('important') ? 'important' : '');
    });
}

function setFavicon(data){
    const link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = data.favicon;
    document.getElementsByTagName('head')[0].appendChild(link);
}

function setTitle(data){
    document.getElementsByTagName('head')[0].getElementsByTagName('title')[0].innerText = `${data.app_name} | ${data.full_app_name}`
}

function hexToRgb(hex) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
}

const userSetDarkMode = () => JSON.parse(getCookie('darkMode') ? getCookie('darkMode') : null);

userSetDarkMode() === null
    ? false
    : document.documentElement.dataset.darkMode = userSetDarkMode();


function currentTheme() {
    const data = window.brandingSettings;
    data.default = !window.isBranded;
    setFavicon(data);
    setCssVars(data);
    setTitle(data);
    return data;
}

export default currentTheme();